import { render } from "./modalResetPassword.vue?vue&type=template&id=277b9b32"
import script from "./modalResetPassword.vue?vue&type=script&lang=js"
export * from "./modalResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__